export default {
  business_name: "The Body Method",
};
